import React, { createContext, useContext, useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const ReshipContext = createContext({ count: 0, refresh: () => {} });
export const useReship = () => useContext(ReshipContext);

export function ReshipProvider({ children }) {
  const { user } = useAuth();
  const [count, setCount] = useState(0);

  const refresh = useCallback(() => {
    if (!user) return;
    api.get("/pending-reshipments/count").then((r) => setCount(r.data.count || 0)).catch(() => {});
  }, [user]);

  useEffect(() => {
    if (!user) { setCount(0); return; }
    refresh();
    const t = setInterval(refresh, 12000);
    const onFocus = () => { if (document.visibilityState !== "hidden") refresh(); };
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onFocus);
    return () => {
      clearInterval(t);
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onFocus);
    };
  }, [user, refresh]);

  return (
    <ReshipContext.Provider value={{ count, refresh }}>
      {children}
    </ReshipContext.Provider>
  );
}
